<template>
    <div>
        <slot name="dialogBtn" />
        <el-dialog
            :title="titleTxt"
            width="480px"
            :class="isChineseEvn ? 'prop-dialog' : 'en-prop-dialog'"
            :append-to-body="true"
            :visible.sync="dialogVisible"
        >
            <el-form ref="form" :model="form" :rules="rules" label-width="95px" label-position="left">
                <el-form-item :label="$i18n.t('zhiji.portrait.tagName')" prop="name" class="prop-item">
                    <el-input v-model="form.name" :placeholder="$i18n.t('zhiji.portrait.writeHold')" />
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.tagType')" prop="classifyId" class="prop-item">
                    <el-select v-model="form.classifyId" style="width: 100%" :placeholder="$i18n.t('zhiji.portrait.selectHold')">
                        <el-option v-for="item in tagOptions" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.paramCondition')" prop="paramJson" class="prop-item prop-item-label">
                    <ConditionList v-model="form.paramJson" :param-options="conditionData" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button round size="" @click="dialogVisible = false">
                    {{ $i18n.t("zhiji.common.cancel") }}
                </el-button>
                <el-button round size="" type="primary" @click="submit">
                    {{ $i18n.t("zhiji.common.confirm") }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ConditionList from "./ConditionList.vue";
import { getTagById, getParamsList, addTagParam, updateTagParam } from "../../service";

export default {
    name: "ParamEdit",
    components: {
        ConditionList
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        tagOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {},
            conditionData: [],
            isChineseEvn: false
        };
    },
    computed: {
        titleTxt() {
            return this.data.type === "edit" ? this.$i18n.t("zhiji.portrait.editTag") : this.$i18n.t("zhiji.portrait.addTag");
        },
        rules() {
            return {
                name: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.name")
                    }
                ],
                classifyId: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.type")
                    }
                ],
                paramJson: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.atLeastOne")
                    }
                ]
            };
        }
    },
    watch: {
        dialogVisible(val) {
            if (val) {
                this.initData();
                // eslint-disable-next-line no-unused-expressions
                this.conditionData.length === 0 ? this.getParamsData() : "";
            }
        },
        titleTxt() {
            this.isChineseEvn = localStorage.getItem("locale") === "cn" ? true : false;
        }
    },
    mounted() {
        this.isChineseEvn = localStorage.getItem("locale") === "cn" ? true : false;
        // window.document.addEventListener("click", this.windowClick);
        this.$slots.dialogBtn[0].elm.addEventListener("click", () => {
            this.dialogVisible = true;
        });
    },
    destroyed() {
        // window.document.removeEventListener("click", this.windowClick);
        this.$slots.dialogBtn[0].elm.removeEventListener("click", () => {
            this.dialogVisible = false;
        });
    },
    methods: {
        initData() {
            // eslint-disable-next-line no-unused-expressions
            this.$refs.form && this.$refs.form.resetFields();
            this.form = {};
            if (this.data.type === "edit" && this.data.id !== undefined) {
                getTagById({ id: this.data.id }).then(result => {
                    this.form = {
                        ...result,
                        paramJson: result.paramJson ? JSON.parse(result.paramJson) : []
                    };
                });
            }
        },
        getParamsData() {
            getParamsList({}).then(result => {
                this.conditionData = result.list.map(item => ({
                    label: item.describe,
                    value: item.id.toString()
                }));
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    // 验证条件参数
                    // eslint-disable-next-line no-unused-expressions
                    !this.checkParams() && this.saveAction();
                } else {
                    return false;
                }
            });
        },
        checkParams() {
            return this.form.paramJson.some(child => {
                if (!child.param_id || !child.condition) {
                    this.$message({
                        showClose: true,
                        message: this.$i18n.t("zhiji.portrait.rules.noEmpty"),
                        type: "warning"
                    });
                    return true;
                }
                return false;
            });
        },
        saveAction() {
            const handlers = {
                edit: this.editAction,
                add: this.addAction
            };
            handlers[this.data.type].call(null);
        },
        addAction() {
            addTagParam(this.form).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        },
        editAction() {
            updateTagParam(this.form).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.el-form {
    .prop-item-label {
        /deep/.el-form-item__label {
            margin-bottom: -8px;
        }
    }
    .prop-item:last-child {
        margin-bottom: 0;
        /deep/.el-form-item__content {
            display: flex;
            width: 100%;
            margin-left: 0 !important;
        }
    }
}

.en-prop-dialog {
    /deep/.el-form-item__label {
        width: 110px !important;
    }
    /deep/.el-form-item__content {
        margin-left: 110px !important;
    }
}
</style>
